import {
  GETVIEWCONGIGURATIONLIST_SUCCESS,
  GETVIEWCONGIGURATIONLIST_FAILED,
  RESET_GETVIEWCONGIGURATIONLIST,
  LOADING_GETVIEWCONGIGURATIONLIST,
  NETWORK_ERROR_GETVIEWCONGIGURATIONLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETVIEWCONGIGURATIONLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETVIEWCONGIGURATIONLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETVIEWCONGIGURATIONLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETVIEWCONGIGURATIONLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETVIEWCONGIGURATIONLIST:
      return (state = initialState);
    default:
      return state;
  }
};
